module.exports = __webpack_public_path__ + "static/media/IMG_0101.696d97ef.JPG";